import axios from '@/axios.js';

export default {
    async fetchTermsPages({commit}) {

        axios.get('/global/pages')
        .then(function (response) {
            commit('FETCH_TERMS_PAGES', response);
        })
        .catch(function (error) {
            console.error(error);
        });
    },
    async termsContent({commit, dispatch}, slug) {
        
        axios.get('/global/pages?slug=' + slug)
        .then(function (response) {
            commit('TERMS_CONTENT', response);
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    clearTermsContent({commit}) {
        commit('CLEAR_TERMS_CONTENT');
    },
    async fetchFaqs({commit}) {
        axios.get('/global/faqs')
        .then(function (response) {
            commit('FAQS', response);
        })
        .catch(function (error) {
            console.error(error);
        });
    }
}